import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';

const VisuallyHidden = styled(Box)`
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap;
`;
VisuallyHidden.displayName = "VisuallyHidden";

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.es.js.map
